import React from "react";
import { Modal, Box, Typography } from "@mui/material";



export default function PopUp({ visibility, content, onClose }) {
  return (
    <>
   
      <Modal open={visibility} onClose={onClose}>
        <Box
          sx={{
            position: "fixed",
            position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
            bgcolor: "#ffffff",            
            color: "#0a1a33",             
            padding: "12px 18px",
            borderRadius: "10px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
            width: { xs: "90%", sm: 400 },
            minWidth: 300,
            maxWidth: "90vw",
            opacity: 1,
            transition: "opacity 0.4s ease-in-out",
            outline: "none",
            border: "none",
          }}
        >
          <Typography>{content}</Typography>
        </Box>
      </Modal>
    </>
  );
}
